export enum EHomeActions {
    GET_HOME = 'GET_HOME',
    GET_HOME_SUCCESS = 'GET_HOME_SUCCESS'
}
